/**
 * The owner's Google Calendar Appointment Schedule does not exist yet — creating one is a
 * one-time manual step on their own Workspace calendar, not something this codebase can do.
 *
 * Until it exists, `DEMO_BOOKING_URL` stays empty and `DemoSection` shows only the lead-capture
 * form (the real, functional part today: it posts to `POST /v1/public/sales-leads`). Once the
 * owner creates the Appointment Schedule and shares its public booking page URL, pasting it here
 * is the entire change — `DemoSection` already branches on whether this is set.
 */
export const DEMO_BOOKING_URL = "";
